import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Modal } from '@/plugins/YoutubeSearch/components';
import * as action from '@/actions/plugins';
import layerPlugins from '@/plugins';

function LayerPluginModal ({ isOpen, openLayerPluginName }) {
  const editor = window.tinymce.activeEditor;
  const dispatch = useDispatch();
  const editorState = useSelector(state => state.editor);

  /**
   * 모달창을 닫음.
   */
  function closeModal () {
    dispatch(action.closeLayerPluginModal());
  }

  /**
   * 팝업이 뜨기 전 에디터 선택으로 복원.
   */
  function restoreLastSelection () {
    editor.selection.setRng(editorState.selectionRange);
  }

  const plugin = layerPlugins[openLayerPluginName];
  if (plugin) {
    const ModalBody = plugin.bodyComponent;
    return (
      <Modal isOpen={isOpen}>
        <ModalBody
          closeModal={closeModal}
          restoreLastSelection={restoreLastSelection}
        />
      </Modal>
    );
  } else {
    return null;
  }
}

export default LayerPluginModal;
